<template>
  <div class="tariffs">
    <page-header title="Тарифы на грузовые перевозки" />
    <div id="tariffs-calculation" class="public-container public-container-mobile">
      <tariffs-calculation />
    </div>
    <tariffs-info />
    <div id="factors" class="public-container public-container-mobile">
      <tariffs-services />
      <popular-directions title="Тарифы на перевозку грузов автомобильным транспортом" />
      <tariffs-companies />
      <public-service-links-grid
        compact
        text-only
        :items="usefulItems"
        title="Полезная информация"
        class="mt-90 tariffs-useful"
      />
      <public-info-grid
        :title="factorsTitle"
        :items="factorsItems"
        class="my-110"
      />
    </div>
  </div>
</template>

<script setup lang="ts">
import { storeToRefs } from 'pinia'
import { useCityStore } from '~/stores/city'
import PageHeader from '~~/components/public/page-header.vue'
import TariffsCalculation from '~~/components/public/tariffs/tariffs-calculation.vue'
import TariffsInfo from '~~/components/public/tariffs/tariffs-info.vue'
import TariffsServices from '~~/components/public/tariffs/tariffs-services.vue'
import TariffsCompanies from '~~/components/public/tariffs/tariffs-companies.vue'
import PublicInfoGrid from '~~/components/public/public-info-grid.vue'
import PopularDirections from '~~/components/public/popular-directions/popular-directions.vue'
import PublicServiceLinksGrid from '~/components/public/public-service-links-grid.vue'
import {getPageContent, replaceContentText} from '~/api/content';
import {PublicInfoGridItem} from '~/types/public'

const { currentCity } = storeToRefs(useCityStore())

const content = await getPageContent('/tariffs')

const usefulItems: PublicInfoGridItem[] = [
  {
    title: 'Терминалы <br> и пункты выдачи',
    link: { to: { name: 'terminals' } }
  },
  {
    title: 'Сборные грузы',
    link: { to: { name: 'delivery-russia' } }
  },
  {
    title: 'Доставка <br> для Яндекс Маркет',
    link: { to: '/yandex-market/' }
  },
  {
    title: 'Доставка <br> от двери до двери',
    link: { to: { name: 'address-delivery' } }
  },
]

const data = computed(() => {
  return content.blocks?.factors
})

const factorsItems = computed(() => [
  {
    icon: {
      url: '/svg/wrapping-box.svg'
    },
    title: data.value.wrappingTitle,
    text: data.value.wrappingText,
    link: {
      title: '"Упаковка"',
      to: { name: 'wrapping' }
    }
  },
  {
    icon: {
      url: '/svg/vz-signature.svg'
    },
    title: data.value.orderEditTitle,
    text: data.value.orderEditText
  },
  {
    icon: {
      url: '/svg/vz-no-time.svg'
    },
    title: data.value.storageTitle,
    text: data.value.storageText,
  },
  {
    icon: {
      url: '/svg/vz-close.svg'
    },
    title: data.value.paramsTitle,
    text: data.value.paramsText,
  }
])

const factorsTitle = computed(() => {
  return replaceContentText(data.value.title, { city: currentCity.value })
})
</script>
